
import React, { Component } from 'react';
import 'moment-timezone';
import 'moment/locale/es';
import { Button, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../css/agenttoolbar/group.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectInteraction } from '../../redux/interactionsSlice';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import SignalRService from '../../controllers/SignalRService';
import GroupConfirmation from './groupconfirmation';
import { removeNotification } from '../utils/utils';

class Group extends Component {

    constructor() {
        super();
        this.state = { time: "00:00:00", seconds: 0, showConfirmation: false };
        this.timer = 0;
        this.count = this.count.bind(this);
        this.enableQueue = this.enableQueue.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
    }

    componentDidMount() {
        this.timer = setInterval(this.count, 1000);
        if (this.props.group === "GLOBAL") {
            console.log(this.props);
            if (this.props.totalCallsInQueue === 0) {
                removeNotification("queue");
            }
        }
        this.setState({
            seconds: this.props.maxWaitingTime
        });
    }

    count() {
        if (this.props.totalCallsInQueue > 0) {
            let seconds = this.state.seconds + 1;
            let result = new Date(seconds * 1000).toISOString().slice(11, 19);

            this.setState({
                time: result,
                seconds: seconds
            });

            if (seconds === 0) {
                clearInterval(this.timer);
            }
        } else {
            this.setState({
                time: "00:00:00",
                seconds: 0
            });
        }

    }

    enableQueue() {
        let data = {
            "extension": this.props.extension,
            "userId": this.props.userId,
            "queue": this.props.group,
            "enable": this.props.disabled
        };

        SignalRService.enableQueue(data, error => {
            console.log(error);
        });
        this.toggleConfirmation();
    }

    toggleConfirmation() {
        this.setState({
            showConfirmation: !this.state.showConfirmation
        });
    }

    render() {
        return (
            <div className="card">
                <div className='card-body px-4 py-6'>
                    <div className="position-relative ps-6 ">
                        {
                            (this.props.group !== "GLOBAL") &&
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t(this.props.closed ? "closed" : "opened")}
                                </Tooltip>}>
                                <div className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-body h-20px w-20px bg-${(this.props.closed ? "danger" : "success")}`}></div>

                            </OverlayTrigger>
                        }
                        <div className={"position-absolute start-0 top-0 w-6px h-100 rounded-2 bg-primary"}></div>
                        <Row>
                            <Col lg={4}>
                                <span className={"badge h-100 fs-6 badge-light-primary"}>{this.state.time}</span>
                            </Col>
                            <Col>
                                <Row>
                                    <Col>
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={<Tooltip style={{ position: "fixed" }}>
                                                {this.props.group}
                                            </Tooltip>}>
                                            <span className={"fs-4 text-primary group-name"}>{this.props.group}</span>
                                        </OverlayTrigger>

                                    </Col>
                                    <Col>
                                        {
                                            (!this.props.disabled && this.props.group !== "GLOBAL") &&
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("disable")}
                                                </Tooltip>}>
                                                <Button variant='light-success' size='sm' className='group-check' onClick={this.toggleConfirmation} disabled={!this.props.disableQueue}>
                                                    <FontAwesomeIcon size='lg' icon={duotone("square-check")} />
                                                </Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            (this.props.disabled && this.props.group !== "GLOBAL") &&
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("enable")}
                                                </Tooltip>}>
                                                <Button variant='light-danger' size='sm' className='group-check' onClick={this.toggleConfirmation} disabled={!this.props.disableQueue}>
                                                    <FontAwesomeIcon size='lg' icon={duotone("square-xmark")} />
                                                </Button>
                                            </OverlayTrigger>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="fs-6 ">{this.props.t("calls")} <span className={"mb-1 text-danger fw-bold"}> {this.props.totalCallsInQueue}</span></div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>
                </div>
                <GroupConfirmation show={this.state.showConfirmation} toggleModal={this.toggleConfirmation} group={this.props.group} disabled={this.props.disabled} enableQueue={this.enableQueue}></GroupConfirmation>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        disableQueue: state.parameters.disableQueue
    };
};

export default compose(connect(mapStateToProps, { selectInteraction }), withTranslation())(Group);
